import { render } from "./AccessCode.vue?vue&type=template&id=6535fc2e&scoped=true"
import script from "./AccessCode.vue?vue&type=script&lang=js"
export * from "./AccessCode.vue?vue&type=script&lang=js"

import "./AccessCode.vue?vue&type=style&index=0&id=6535fc2e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6535fc2e"]])

export default __exports__